module.exports = __webpack_public_path__ + "img/device-Information_3.8a9d15aa.png";